import React from 'react';
import { Loading } from 'antd-mobile'
import './index.scss'

export interface AiLoadingProps {
    loadingText?:string
    color?:string
    _style?:object
}


const AiLoading: React.FC<AiLoadingProps> = ({ loadingText = '数据加载中', color = 'rgb(153, 153, 153)', _style = {} }) => {
    return <div className='loading-wrapper' style={{color,..._style}}><span>{loadingText}</span><Loading /></div>
}

export default AiLoading
